//@flow
import * as React from 'react';
import {
    Text,
    Box,
    Stack,
    Columns,
    Column,
    Divider,
    Icon as NeoIcon,
    Button as NeoButton
} from '@locus-taxy/neo-ui';
import theme from './FpVisitMarkerPopup.scss';
import moment from 'moment-timezone';
import { type BeatVisit } from 'common/models/internal/BeatVisit';
import { type TFunction } from 'react-i18next';
import type UnitConversionHelper from 'common/helpers/UnitConversionHelper';
import { Units } from 'common/enums/UnitEnum';

type Props = {
    beatId: string,
    visit: BeatVisit,
    index: number,
    salesCategory: string,
    salesmanId: string,
    getContainer: () => string,
    onPopUpCloseClick: () => void,
    status: string,
    t: TFunction,
    label: string,
    UnitConverter: UnitConversionHelper
};

export default class FpHomebaseMarker extends React.PureComponent<Props> {
    render() {
        const {
            salesCategory,
            salesmanId,
            visit,
            onPopUpCloseClick,
            beatId,
            UnitConverter,
            t
        } = this.props;

        const { startTime, completedTime } = visit.eta;
        const startTimeLabel = moment(startTime).format('h:mm a');
        const endTimeLabel = moment(completedTime).format('h:mm a');
        const transactionDuration = 30;
        let formattedTransactionDuration;
        if (transactionDuration > 60 * 60 - 1) {
            // greater then 59 mins
            formattedTransactionDuration = UnitConverter.convertSeconds({
                roundOff: true,
                value: transactionDuration
            }).valueString;
        } else {
            formattedTransactionDuration = UnitConverter.convertSeconds({
                roundOff: true,
                value: transactionDuration,
                conversionScale: Units.conversionScale.Base
            }).valueString;
        }
        return (
            <Box className={theme.popupInner} p={2}>
                <Stack space="small">
                    <Box height="auto">
                        <Columns space="medium">
                            <Column width="content" height="inherit">
                                <NeoIcon
                                    color="grey.500"
                                    icon="motiontrack_homebase"
                                    size="large"
                                />
                            </Column>
                            <Column width="fluid">
                                <Stack space="small">
                                    <Box>
                                        <Text fontSize={2} fontWeight={600}>
                                            {salesmanId}
                                        </Text>
                                    </Box>

                                    <Box>
                                        <Text fontSize={1} fontWeight={500}>
                                            {beatId}
                                        </Text>
                                    </Box>
                                </Stack>
                            </Column>

                            <Column width="content">
                                <Columns space="small">
                                    <NeoButton
                                        appearance="icon"
                                        icon="cross"
                                        onClick={onPopUpCloseClick}
                                    />
                                </Columns>
                            </Column>
                        </Columns>
                    </Box>
                    <Divider color="grey.200" />
                    <Box p={1}>
                        <Columns space="small">
                            <Text
                                fontWeight={500}
                                fontSize={1}
                                color="grey.500"
                            >
                                {t('entityManagement:fpPlanView.salesCategory')}
                            </Text>
                            <Text> {salesCategory}</Text>
                        </Columns>
                    </Box>
                    <Divider color="grey.200" />
                    <Box p={1} height="auto">
                        <Columns>
                            <Column>
                                <Columns space="small">
                                    <NeoIcon
                                        color="grey.500"
                                        icon="location_on"
                                        size="medium"
                                    />
                                    <Text>{startTimeLabel}</Text>
                                </Columns>
                            </Column>

                            <Column>
                                <Columns>
                                    <NeoIcon
                                        color="grey.500"
                                        icon="dispatcher_eta"
                                        size="medium"
                                    />
                                    <Text>{endTimeLabel}</Text>
                                </Columns>
                            </Column>
                            <Column>
                                <Columns space="small">
                                    <NeoIcon
                                        color="grey.500"
                                        icon="clock"
                                        size="medium"
                                    />
                                    <Text>{formattedTransactionDuration}</Text>
                                </Columns>
                            </Column>
                        </Columns>
                    </Box>
                </Stack>
            </Box>
        );
    }
}
